/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SiteNavDropdownContent_navigationModule$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SiteNavItem_navigationModule$ref: FragmentReference;
export type SiteNavItem_navigationModule = {|
  +imageLink: ?string,
  +name: ?string,
  +isLinkable: ?boolean,
  +url: ?string,
  +isHighlighted: ?boolean,
  +items?: ?$ReadOnlyArray<?{|
    +serviceId: ?string,
    +name: ?string,
    +column: ?string,
    +items: ?$ReadOnlyArray<?{|
      +serviceId: ?string,
      +name: ?string,
      +isLinkable: ?boolean,
      +url: ?string,
    |}>,
  |}>,
  +$fragmentRefs: SiteNavDropdownContent_navigationModule$ref,
  +$refType: SiteNavItem_navigationModule$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isLinkable",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "SiteNavItem_navigationModule",
  "type": "NavigationModule",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchSubNav",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SiteNavDropdownContent_navigationModule",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageLink",
      "args": null,
      "storageKey": null
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isHighlighted",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchSubNav",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "items",
          "storageKey": null,
          "args": null,
          "concreteType": "NavigationTopLevel",
          "plural": true,
          "selections": [
            (v3/*: any*/),
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "column",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": "NavigationItem",
              "plural": true,
              "selections": [
                (v3/*: any*/),
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b3d891b71efec613cfd2d738466e0686';
module.exports = node;
